import type { Client } from '@altyor-kronos/shared-types';
import { usePolledResource } from '../../core/data/usePolledResource';
import { apiGet } from '../../core/data/restClient';

export interface ClientDocState {
  client: Client | null;
  loading: boolean;
  error: Error | null;
}

/**
 * Read a single `clients/{id}` doc. Shared by `FinanceTable`
 * (rate-resolution context, ignores loading/error) and `ClientDetailPage`
 * (profile view, renders the error). FinanceTable never reads the `error` field.
 */
export function useClientDoc(clientId: string): ClientDocState {
  const { rows, loading, error } = usePolledResource<Client & { id: string }>(
    clientId || null,
    // Un 404 remonte tel quel : ApiError porte déjà un message traduit (#66).
    async () => [await apiGet<Client & { id: string }>(`/clients/${clientId}`)],
  );
  return { client: rows[0] ?? null, loading, error };
}
